/* jshint esversion: 6 */
/* jshint ignore:start */
import Lottie from 'lottie-react';
import LoadingLottie from "../component/Lottie/loader-main.json";

const Loading = ({ CustomeStyle, index }) => {
    return (
        <div className={CustomeStyle}>
            <Lottie
                className={`w-[280px] ${index !== 0 && "-mt-[50px]"}`}
                animationData={LoadingLottie}
                loop={true}
            />
        </div>
    )
}

export default Loading
/* jshint ignore:end */